import React from "react";
import AdminPlaceholder from "@/components/site/PortalPlaceholder";

export default function PatientAnalytics() {
    return (
        <AdminPlaceholder
            eyebrow="Tracking / Patient analytics"
            title="Patient analytics"
            description="Cross-patient behavioural and clinical analytics. Tells us where treatment compliance is breaking down and where doctors need to intervene."
            bullets={[
                "Avg wear-time per patient (requires the patient wear-time tracker to ship first)",
                "% of patients past their expected stage at this point in treatment",
                "Drop-off funnel: aligners delivered → first wear logged → 30-day adherence → final retainer",
                "Top doctors by patient adherence; bottom 10% for intervention",
                "Photo check-in completion rates per clinic",
            ]}
            wave="Wave 3"
            note="Depends on Patient Portal P1 features: wear-time tracking + weekly photo check-ins. Until those ship, this page will show clean empty states with sample-data badges."
        />
    );
}
